"use client";

import { cn } from "@/lib/utils";

/** Lớp trang trí nền cho header / sidebar top — không chặn tương tác. */
export function TrungThuHeaderDecor({ className }: { className?: string }) {
  return (
    <div
      className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
      aria-hidden
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_15%_0%,rgba(251,191,36,0.18),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_85%_0%,rgba(244,63,94,0.12),transparent_50%)]" />
      <div className="absolute -left-8 top-1/2 h-24 w-24 -translate-y-1/2 rounded-full bg-amber-400/10 blur-2xl" />
      <div className="absolute -right-6 top-0 h-20 w-20 rounded-full bg-orange-500/10 blur-2xl" />

      {/* Đèn lồng trái */}
      <div className="absolute left-[8%] top-1 hidden animate-[pulse_3s_ease-in-out_infinite] text-lg opacity-70 sm:block">
        🏮
      </div>
      <div className="absolute left-[18%] top-2 hidden animate-[pulse_4s_ease-in-out_infinite_0.5s] text-sm opacity-50 md:block">
        ✨
      </div>

      {/* Trăng + đèn phải */}
      <div className="absolute right-[14%] top-0.5 hidden text-base opacity-80 sm:block">🌕</div>
      <div className="absolute right-[6%] top-2 hidden animate-[pulse_3.5s_ease-in-out_infinite_1s] text-lg opacity-65 md:block">
        🏮
      </div>

      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />
    </div>
  );
}

export function TrungThuSeasonBadge({ compact, className }: { compact?: boolean; className?: string }) {
  if (compact) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 rounded-full border border-amber-400/40 bg-amber-500/15 px-2 py-0.5 text-[10px] font-semibold text-amber-200",
          className
        )}
      >
        🌕 Trung Thu
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-amber-400/35 bg-gradient-to-r from-amber-500/20 to-rose-500/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-amber-100 shadow-sm",
        className
      )}
    >
      <span className="text-xs">🏮</span>
      Mừng Trung Thu
      <span className="text-xs">🌕</span>
    </span>
  );
}
